module.exports = __webpack_public_path__ + "static/media/n10.9387c119.jpg";